import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import GridList from '@material-ui/core/GridList';
import GridTile from '@material-ui/core/GridListTile';
import FavoritesController from '../../FavoritesController';
import { getFileURL, getLocalizedName } from '../../helpers';
import { withRouter } from 'react-router-dom';
import styles from './FavoritesStyle';
import StoreController from '@projeccions-pdc/frontend-storage';
import Loader from '../Common/Loader';
import { isSmartphone, parseToBoolean } from '../../helpers';
import LocalizedStrings from '../Localization/localization';
import AppContext from '../../AppContext';

class Favorites extends Component {
    constructor(props) {
        super(props);
        this.state = {
            favoritesData: [],
            loading: true,
            smartphoneView: undefined,
        };

        let appContext = new AppContext();
        let currentUserSub = appContext.getMyInfo().userSub;
        this._FavoritesController = new FavoritesController(appContext.getPlatformId(), currentUserSub);
        this._StoreController = new StoreController(appContext.getPlatformId(), currentUserSub);
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    }

    async componentDidMount() {
        let appContext = new AppContext();
        appContext.addObserver('favComponent', this);
        this.removeListener = isSmartphone((match) => this.handleSizeChange(match));
        await this.refreshFavs();
    }

    componentWillUnmount() {
        this.removeListener();
        let appContext = new AppContext();
        appContext.removeObserver('favComponent');
    }

    notifyDataHasChanged = async () => {
        await this.refreshFavs();
    }

    async componentDidUpdate(prevProps, prevState) {
        // if (prevProps.platformId !== this.props.platformId) {
        //     await this.refreshFavs();
        // }
    }

    async refreshFavs() {
        try {
            let favoritesData = this._StoreController.get('myFavorites');
            this.setState({ favoritesData, loading: false });
            favoritesData = await this._FavoritesController.getFavorites();
            this.setState({ favoritesData, loading: false });
        } catch (err) {
            console.log(err);
            this.setState({ loading: false });
        }
    }

    handleOpenFav = (fav) => {
        let to;
        if (fav.objectType === 'm') {
            to = `/metadocument/show/${fav.contentId}`;
        } else if (fav.objectType === 'c') {
            to = `/category/show/${fav.contentId}`;
        }
        this.props.history.push(to);
    }

    getBackgroundStyle = (fav) => {
        let backgroundStyle = {};
        let previewImageOrColor = parseToBoolean(
            (fav.properties !== undefined && fav.properties.previewImageOrColor !== undefined) ? fav.properties.previewImageOrColor : false
        );

        if (previewImageOrColor === true) {
            let previewColor = fav.properties.previewColor !== undefined ? fav.properties.previewColor : '#8a7b70';
            backgroundStyle = {
                backgroundColor: previewColor
            };
        } else {
            backgroundStyle = {
                backgroundImage: 'url(' + (fav.previewImage ? getFileURL(fav.previewImage) : undefined) + ')',
            };
        }
        return backgroundStyle;
    }

    render() {
        let columns = 3;
        if (this.state.smartphoneView === true) {
            columns = 1;
        }
        let language = new AppContext().getLanguage();
        return (
            <Fragment>
                <div className={`App-page-background ${this.props.backgroundColor}`} />
                <div style={styles.container}>
                    <div style={styles.title}>
                        {LocalizedStrings.favorites}
                    </div>
                    {this.state.loading === true ?
                        <Loader loading={true} size={'30px'} />
                        :
                        this.state.favoritesData ?
                            <GridList
                                cols={columns}
                                cellHeight={150}
                                spacing={10}
                                style={styles.gridList}>

                                {this.state.favoritesData.map(fav => {
                                    let backgroundStyle = this.getBackgroundStyle(fav);
                                    return (
                                        <GridTile
                                            data-id={fav.contentId}
                                            data-type="fav"
                                            key={fav.contentId}
                                            cols={fav.featured ? 2 : 1}
                                            rows={fav.featured ? 2 : 1}
                                            onClick={() => this.handleOpenFav(fav)}>
                                            <div style={styles.align}>
                                                <div style={{ ...styles.favItem, ...backgroundStyle }}>
                                                    <div style={styles.overlay}>
                                                        <div style={styles.name}>
                                                            {/* <Star color='#fff' style={{ height: '20px', width: '20px', marginRight: '10px', verticalAlign: 'bottom' }} /> */}
                                                            <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: getLocalizedName(language, fav.names) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </GridTile>
                                    );
                                })}
                            </GridList>
                            : ''}
                </div>
            </Fragment>

        );
    }
}
Favorites.propTypes = {
    history: PropTypes.object.isRequired,
    backgroundColor: PropTypes.string.isRequired,
};

export default withRouter(Favorites);